import React from 'react';
import translate from '../locales/quote';
import Popup from '../components/popup';

function Quote() {
    return (
        <div className="quote angle">
            <div className="large container medium-padding-vertical white">
                <blockquote>{translate.content}</blockquote>
                <p className="large-text"><b>{translate.president.name}</b><br />
                {translate.president.title}</p>
                <Popup more={translate.button} close={translate.closeButton} ariaLabel={translate.button} class="quotePopup button" contentClass="quotePopupContent" content={translate.innerContent}/>
            </div>
        </div>
    )
}

export default Quote;